<template>
  <div :class="[$style.container]" @dragenter.stop.prevent="onDragEnter">
    <div v-if="!chat" :class="$style.placeholder">
      <div>{{ $t('chat.selectPlaceholder') }}</div>
    </div>
    <template v-else>
      <transition name="fade">
        <div
          v-show="isDropFile"
          :class="[$style.dropzone]"
          @dragenter.stop.prevent="onDragEnter"
          @dragover.stop.prevent="onDragEnter"
          @dragleave.stop.prevent="onDragLeave"
          @drop.stop.prevent="onDrop"
        >
          <div :class="$style.dropzoneText">
            <BaseIcon name="upload" :class="$style.dropzoneIcon" />
            <br />
            {{ $t('chat.dropZone') }}
          </div>
        </div>
      </transition>
      <div ref="messageList" :class="$style.messageListWrap">
        <div ref="messageListContent" :class="[$style.messageList, { [$style.messageListActive]: isShowActions }]">
          <!-- <div v-if="!isLoading && !messages.length" :class="$style.placeholder">
            <div>No messages here yet</div>
          </div>
          <Spinner v-if="isLoading" /> -->

          <infinite-loading
            v-if="!foundMessages && isWSOpened"
            direction="top"
            :identifier="infiniteId"
            @infinite="infiniteHandler"
            :class="$style.infiniteLoading"
          >
            <Spinner slot="spinner" />
            <div slot="no-more"></div>
            <div v-show="!messages.length" slot="no-results" :class="$style.placeholder">
              <div>{{ $t('chat.noMessagesPlaceholder') }}</div>
            </div>
            <div slot="error" slot-scope="{ trigger }">
              {{ $t('chat.errorMessagesLoading') }}.
              <span class="link" @click="trigger">{{ $t('chat.retryMessagesLoading') }}</span>
            </div>
          </infinite-loading>
          <Message
            v-for="(message, index) in messages"
            :key="message.id"
            v-bind="{
              message,
              isShowDay: isShowDay(message),
              isPicked: isMessagePicked(message),
              isForwarded: isForward(message),
              isShowUserName: calculateShowingAttributesDates(message, index, true),
              isShowAvatar: calculateShowingAttributesDates(message, index, false),
              class: [$style.messageItem]
            }"
            ref="messages"
            @pick="pickMessage(message)"
            @scroll-to-msg="scrollToMessage"
            @reply="repliedMessage = message"
          />
        </div>
      </div>
      <div :class="[$style.bottomWrap]">
        <div v-if="isShowActions" :class="$style.actions">
          <dir :class="$style.actionsGroup">
            <BaseButton
              v-if="isPremium"
              v-tooltip="$t('chat.actions.translate')"
              @click="onTranslate"
              oval
              :loading="isTranslating"
              :class="$style.actionsButton"
              ><BaseIcon name="language" /> {{ pickedCount }}</BaseButton
            >
            <BaseButton v-tooltip="$t('chat.actions.forward')" @click="onForward" oval :class="$style.actionsButton"
              ><BaseIcon name="reply-all" /> {{ pickedCount }}</BaseButton
            >
            <BaseButton v-tooltip="$t('chat.actions.delete')" @click="onDelete" oval :class="$style.actionsButton"
              ><BaseIcon name="trash-alt" /> {{ pickedCount }}</BaseButton
            >
            <DeleteMessages :messageIds="pickedMessagesIds" :beforeDelete="cancelPicking" />
            <template v-if="isShowSingleActions">
              <BaseButton v-tooltip="$t('chat.actions.reply')" @click="onReply" oval :class="$style.actionsButton"
                ><BaseIcon name="share" /> {{ pickedCount }}</BaseButton
              >
              <BaseButton
                v-if="isShowEdit"
                oval
                :class="$style.actionsButton"
                v-tooltip="$t('chat.actions.edit')"
                @click="onEdit"
              >
                <BaseIcon name="pencil-alt" /> {{ pickedCount }}
              </BaseButton>
            </template>
          </dir>
          <BaseButton @click="cancelPicking" oval secondary :class="$style.actionsButton">{{
            $t('chat.actions.cancel')
          }}</BaseButton>
        </div>
        <VoiceRecorder v-else-if="isVoiceRecording" @close="isVoiceRecording = false" @recorded="sendVoice" />
        <template v-else>
          <div :class="$style.extraBlock">
            <MessageReply v-if="repliedMessage" :message="repliedMessage">
              <BaseIcon @click="clearReply" custom name="close" :class="$style.replyClose" />
            </MessageReply>
            <MessageReply v-if="editedMessage" :message="editedMessage" isEdit>
              <BaseIcon @click="clearEdit" custom name="close" :class="$style.replyClose" />
            </MessageReply>
            <div v-if="attachment" :class="$style.attachmentPreview">
              <BaseIcon name="paperclip" />
              <div :class="$style.attachmentPreviewBody">
                <span :class="$style.attachmentPreviewName">{{ attachment.name }}</span>
                <span :class="$style.attachmentPreviewSize">({{ attachmentSize }})</span>
              </div>
              <BaseIcon @click="clearAttachment" custom name="close" :class="$style.attachmentPreviewClose" />
            </div>
          </div>
          <div :class="$style.mentionWrap" v-click-outside="hideMentions" v-show="isShowMentions">
            <ul :class="$style.mentionUserList">
              <li
                v-for="user in mentionAvailableUsers"
                :key="user.id"
                :class="$style.mentionUserItem"
                @click="insertMention(user.nickname)"
              >
                <div :class="$style.mentionUserItemAvatar">
                  <Avatar :user="user" :size="30" />
                </div>
                <div :class="$style.mentionUserItemName">
                  <strong>{{ user.firstName }}</strong> @{{ user.nickname }}
                </div>
              </li>
            </ul>
          </div>
          <div :class="[$style.sendMessageForm]">
            <div :class="$style.avatarContainer">
              <Avatar :user="user" :size="40" />
            </div>
            <div :class="$style.messageContainer">
              <!-- :popoverInnerClass="['tooltip-inner popover-inner']" -->
              <input
                v-model="subject"
                :placeholder="$t('chat.subject')"
                type="text"
                :class="$style.inputSubject"
                @keydown.enter.exact.prevent
                @keyup.enter.exact="onSubmit"
              />
              <textarea
                :value="text"
                :placeholder="$t('chat.inputPlaceholder')"
                rows="3"
                ref="textarea"
                :class="$style.input"
                @keydown.enter.exact.prevent
                @keyup.enter.exact="onSubmit"
                @keyup.shift.enter.exact="() => {}"
                @keyup.up.exact="onTextKeyupUp"
                @input="onTextInput"
              ></textarea>
            </div>
            <div :class="$style.buttons">
              <div :class="$style.buttonsMore">
                <v-popover
                  placement="top-end"
                  offset="5"
                  :popoverInnerClass="['tooltip-inner popover-inner', $style.picker]"
                >
                  <BaseIcon :name="['far', 'smile']" :class="[$style.btnMore, 'tooltip-target']" />
                  <Picker slot="popover" @insert:emoji="insertToText" @insert:gif="sendGif" />
                </v-popover>
                <FileInput ref="fileInput1" @input="onFileChange" accept="image/*">
                  <BaseIcon :name="'camera'" :class="$style.btnMore" />
                </FileInput>
                <FileInput ref="fileInput2" @input="onFileChange">
                  <BaseIcon :name="'paperclip'" :class="$style.btnMore" />
                </FileInput>
                <BaseIcon @click="onVoice" name="microphone" :class="$style.btnMore" />
              </div>
              <button @click="onSubmit" :class="$style.buttonSend">
                {{ $t('chat.actions.send') }}
                <BaseIcon custom name="locationArrow" :class="$style.buttonSendIcon" />
              </button>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Message from './Message'
import MessageContent from './MessageContent/index.vue'
import Avatar from '@/components/Avatar'
import Picker from './Picker'
import { startOfDay } from 'date-fns'
import FileInput from '@/components/FileInput'
import MessageReply from './MessageReply'
import Vue from 'vue'
import Spinner from '@/components/Spinner'
import DeleteMessages from '@/components/modals/DeleteMessages'
import InfiniteLoading from 'vue-infinite-loading'
import { findLast, get, cloneDeep, throttle } from 'lodash'
import { TYPE_CODE, ATTACHMENT_CODE } from '@/models/Message'
import api from '@/api'
import superbytes from 'superbytes'
import VoiceRecorder from './VoiceRecorder'
import chunkText from 'chunk-text'
import urlRegex from 'url-regex'
import { parseRouterQueryParam } from '@/helpers'

Vue.component('Message', Message)
Vue.component('MessageContent', MessageContent)

const FILE_SIZE_LIMIT = 50
const FILE_NAME_LENGTH_LIMIT = 50
const PAGE_LIMIT = 30

const regExp = RegExp(/\.(.+)$/gm)
const truncateFilename = filename => {
  if (filename.length <= FILE_NAME_LENGTH_LIMIT) return filename
  const [name, ext] = filename.split(regExp)
  const shortName = name.slice(0, FILE_NAME_LENGTH_LIMIT - (ext.length + 1))
  return `${shortName}.${ext}`
}

const getImageFromFile = file => {
  return new Promise((resolve, reject) => {
    let fr = new FileReader()
    fr.onerror = reject
    fr.onload = event => {
      let img = new Image()
      img.onload = () => {
        // resolve(`${img.width}x${img.height}`)
        resolve(img)
      }
      img.src = fr.result
    }
    fr.readAsDataURL(file)
  })
}

export default {
  name: 'chat-view',
  components: {
    Avatar,
    Picker,
    FileInput,
    MessageReply,
    DeleteMessages,
    Spinner,
    InfiniteLoading,
    VoiceRecorder
  },
  props: {
    highlightMessageId: Number
  },
  data () {
    return {
      text: '',
      subject: '',
      pickedMessagesIds: [],
      repliedMessage: null,
      editedMessage: null,
      isLoading: false,
      // page: 0,
      // datetimeTo: null,
      infiniteId: +new Date(),
      isDropFile: false,
      attachment: null,
      isShowMentions: false,
      isTranslating: false,
      isVoiceRecording: false,
      isScrolling: false,
      mentionText: '',
      pointPositionTextarea: 0
    }
  },
  watch: {
    activeChatId: {
      handler: 'onChatChange',
      immediate: true
    },
    async 'messages.length' (newLength, oldLength) {
      await this.$nextTick()
      if (!this.$refs.messageList) return
      const { scrollTop, scrollHeight, offsetHeight } = this.$refs.messageList
      if ((oldLength === 0 && newLength > 0) || scrollTop > scrollHeight - offsetHeight * 2) {
        this.goBottom()
      }
    },
    '$route.query.highlightedMessageId' (highlightedMessageId) {
      if (!highlightedMessageId) return
      this.scrollToMessage(highlightedMessageId)
    }
  },
  computed: {
    ...mapGetters({
      isWSOpened: 'ws/isOpened',
      user: 'auth/user',
      isPremium: 'auth/isPremium',
      chatById: 'entities/chats/getById',
      messagesByChat: 'entities/messages/listByChatId',
      messageById: 'entities/messages/find'
    }),
    activeChatId () {
      return parseRouterQueryParam(this.$route.query.id, true)
    },
    chat () {
      if (!this.activeChatId) return
      return this.chatById(this.activeChatId)
    },
    isGroupChat () {
      return this.chat && this.chat.typeName === 'group'
    },
    foundMessages () {
      return this.$store.state.entities.messages.foundMessages
    },
    messages () {
      return this.foundMessages ? this.foundMessages : this.messagesByChat(this.activeChatId) // || initialList
    },
    firstMessagesByDay () {
      const result = this.messages.reduce((res, message) => {
        if (message.deleted) return res
        const dayBeginTimestamp = startOfDay(new Date(message.createdTs)) * 1
        const savedMessage = res[dayBeginTimestamp]
        if (!savedMessage || +new Date(message.createdTs) < +new Date(savedMessage.createdTs)) {
          res[dayBeginTimestamp] = message
        }
        return res
      }, {})
      return result
    },
    isShowActions () {
      return !!this.pickedCount
    },
    isShowSingleActions () {
      return this.pickedMessagesIds.length === 1
    },
    isShowEdit () {
      const selectedMessage = this.messageById(this.pickedMessagesIds[0])
      return (
        this.isShowSingleActions && selectedMessage.senderId === this.user.id && selectedMessage.type === TYPE_CODE.text
      )
    },
    pickedCount () {
      return this.pickedMessagesIds.length
    },
    replyTo () {
      if (!this.repliedMessage) return
      const {
        id,
        payload,
        senderId,
        type,
        properties: { subject },
        attachment
      } = this.repliedMessage
      let replyTo = {
        id,
        payload,
        senderId,
        type,
        properties: {
          subject
        }
      }
      if (attachment) {
        replyTo.attachment = attachment
      }
      return replyTo
    },
    attachmentSize () {
      return this.attachment ? superbytes(this.attachment.size) : null
    },
    datetimeTo () {
      if (!this.messages.length) return new Date().toISOString().slice(0, -1)
      return new Date(this.messages[0].createdTs - 1).toISOString().slice(0, -1)
    },
    mentionAvailableUsers () {
      return this.chat.participantsUsers.filter(user => user && user.nickname && user.userId !== this.user.id)
    }
  },
  mounted () {
    const { messageList } = this.$refs
    this.resizeObserver = new ResizeObserver(() => {
      const { scrollTop, scrollHeight, offsetHeight } = messageList
      if (scrollTop > scrollHeight - offsetHeight * 2) {
        this.goBottom()
      }
    })

    document.onpaste = event => {
      const file = this.getFileFromPasteEvent(event)
      if (!file) {
        return
      }

      const elem = this.$refs.textarea
      if (elem === document.activeElement) {
        this.attachment = file
        this.sendAttachment()
      }
      setTimeout(() => {
        this.text = ''
      }, 1)
    }
  },
  beforeDestroy () {
    const { messageListContent } = this.$refs
    if (this.resizeObserver) {
      messageListContent && this.resizeObserver.unobserve(messageListContent)
      this.resizeObserver.disconnect()
    }

    messageListContent.removeEventListener('click', this.clickOnTagAToOpenANewTab, true)
  },
  methods: {
    goBottom () {
      if (!this.$refs.messageList) return
      this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
    },
    goBottomDelayed () {
      this.$nextTick(() => {
        setTimeout(this.goBottom, 400)
      })
    },
    isScrolled () {
      const el = this.$refs.messageList
      if (!this.chat || !el) return
      if (this.isScrolling) return true
      return el.scrollTop + el.clientHeight < el.scrollHeight
    },
    ...mapActions({
      getChatMessages: 'entities/messages/fetch',
      sendMessageWithPending: 'entities/messages/sendWithPending',
      sendMessage: 'entities/messages/send',
      editMessage: 'entities/messages/edit',
      addPending: 'entities/messages/addPending',
      translate: 'entities/translatedMessages/translate',
      typing: 'entities/messages/typing',
      getUserProfiles: 'entities/users/getProfiles'
    }),
    getFileFromPasteEvent (event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items
      for (let index in items) {
        const item = items[index]
        if (item.kind === 'file') {
          return item.getAsFile()
        }
      }
    },
    async onChatChange () {
      this.clearPickedMessages()
      this.editedMessage = null
      this.repliedMessage = null
      this.text = ''
      this.subject = ''
      this.page = 0
      this.infiniteId += 1
      if (!this.chat) return
      this.getUserProfiles(this.chat.participantsUsers.map(user => user?.userId))
      await this.$nextTick()
      this.goBottom()
      // if (this.messages.length) {
      //   await this.fetchMessages()
      //   this.$nextTick(this.goBottom)
      // }
    },
    async fetchMessages () {
      if (!this.chat) return
      this.isLoading = true
      const { activeChatId, datetimeTo } = this // datetimeTo
      try {
        const messages = await this.getChatMessages({
          chatId: activeChatId,
          limit: PAGE_LIMIT,
          datetimeTo
        })
        return messages
      } catch (e) {
        return e
      } finally {
        this.isLoading = false
      }
    },
    async infiniteHandler ($state) {
      if (this.foundMessages) return
      try {
        const messages = await this.fetchMessages()
        if (!messages) {
          $state.error()
          return
        }
        if (messages.length < PAGE_LIMIT) {
          $state.complete()
        } else {
          $state.loaded()
        }
      } catch (e) {
        $state.error()
      }
    },
    async onSubmit () {
      if (this.editedMessage) {
        await this.editText()
      } else if (this.attachment) {
        await this.sendAttachment()
      } else {
        await this.sendText()
      }
    },
    prepareMessagesData (params) {
      const { text, subject } = this
      this.text = ''
      this.subject = ''
      let data = {
        chatId: this.activeChatId,
        type: TYPE_CODE.text,
        ...params
      }
      if (subject) {
        data.properties = data.properties || {}
        data.properties.subject = subject
      }
      if (this.repliedMessage) {
        data.properties = data.properties || {}
        data.properties.replyTo = this.replyTo
        this.clearReply()
      }
      if (!text) {
        return [data]
      }
      const textChunks = chunkText(text, 10000)
      return textChunks.map(textChunk => {
        const chunkData = cloneDeep(data)
        if (urlRegex().test(textChunk)) {
          chunkData.properties = chunkData.properties || {}
          chunkData.properties.hasLink = true
        }
        return {
          payload: textChunk,
          ...chunkData
        }
      })
    },
    async sendText () {
      if (!this.text) return
      const messagesDataList = this.prepareMessagesData()
      setTimeout(this.goBottom, 0)
      for (const data of messagesDataList) {
        await this.sendMessageWithPending(data)
      }
    },
    async editText () {
      if (!this.text) return
      const { id, chatId } = this.editedMessage
      const { text, subject } = this
      const data = {
        id,
        chatId,
        payload: text,
        properties: {}
      }
      if (subject) {
        data.properties.subject = subject
      }
      this.text = ''
      this.subject = ''
      this.clearEdit()
      await this.editMessage(data)
    },
    clearAttachment () {
      this.attachment = null
      this.$refs.fileInput1.clear()
      this.$refs.fileInput2.clear()
    },
    onFileChange (file) {
      this.attachment = file
    },
    validate () {
      const file = this.attachment
      if (!file) return false
      const size = file.size * Math.pow(10, -6)
      if (size > FILE_SIZE_LIMIT) {
        this.$modal.show('info', {
          text: this.$t('chat.fileSizeMbLimitInfo', { n: FILE_SIZE_LIMIT })
        })
        return false
      }
      return true
    },
    async sendAttachment () {
      if (!this.validate()) return

      const file = this.attachment
      this.clearAttachment()
      let [fileType] = file.type.split('/')
      const type = ATTACHMENT_CODE[fileType] || ATTACHMENT_CODE.file
      const messagesDataList = this.prepareMessagesData()
      const [attachmentMessageData, ...textMessagesDataList] = messagesDataList
      attachmentMessageData.type = TYPE_CODE.attachment
      const { name, size } = file
      attachmentMessageData.attachment = { type, name: truncateFilename(name), size }
      if (fileType === 'image') {
        const img = await getImageFromFile(file)
        attachmentMessageData.attachment.resolution = `${img.width}x${img.height}`
        attachmentMessageData.attachment.link = img.src
      }
      const pendingData = cloneDeep(attachmentMessageData)
      pendingData.attachment.progress = 0
      const pendingMsgId = await this.addPending(pendingData)
      const pendingMsg = this.messageById(pendingMsgId)
      const link = await api.media.upload(file, progressEvent => {
        const progress = progressEvent.loaded / progressEvent.total
        pendingMsg.$update({
          attachment: { ...pendingData.attachment, progress }
        })
      })
      attachmentMessageData.attachment.link = link
      setTimeout(this.goBottom, 0)
      await this.sendMessage(attachmentMessageData)
      pendingMsg.$delete()
      for (const textMessageData of textMessagesDataList) {
        await this.sendMessageWithPending(textMessageData)
      }
    },
    insertToText (symbol) {
      this.text += symbol
    },
    async sendGif (giphyId) {
      let data = {
        type: TYPE_CODE.giphy,
        payload: { giphyId }
      }
      if (this.repliedMessage) {
        data.properties.replyTo = this.replyTo
        this.clearReply()
      }
      await this.sendMessageWithPending({
        chatId: this.activeChatId,
        ...data
      })
    },
    isShowDay (message) {
      const dayBeginTimestamp = startOfDay(new Date(message.created)) * 1
      const firstMessage = this.firstMessagesByDay[dayBeginTimestamp]
      if (!firstMessage) return false
      return firstMessage.id === message.id
    },
    calculateShowingAttributesDates (message, index, isName = false) {
      if (message.type === 0) {
        return false
      }
      const delta = 20 * 60 * 1000 // 20 min
      const nextMessage = this.messages[index + 1]
      const prevMessage = this.messages[index - 1]
      if (isName) {
        if (!prevMessage) {
          return true
        }
        if (prevMessage.type === 0) {
          return true
        }
        if (message.senderId !== prevMessage.senderId) {
          return true
        }
        return new Date(message.created) * 1 - new Date(prevMessage.created) * 1 > delta
      } else {
        if (!nextMessage) {
          return true
        }
        if (message.senderId !== nextMessage.senderId) {
          return true
        }
        return new Date(nextMessage.created) * 1 - new Date(message.created) * 1 > delta
      }
    },
    pickMessage (message) {
      const existedIndex = this.pickedMessagesIds.indexOf(message.id)
      const isSelected = existedIndex !== -1
      if (isSelected) {
        this.pickedMessagesIds.splice(existedIndex, 1)
      } else {
        this.pickedMessagesIds.push(message.id)
      }
    },
    clearPickedMessages () {
      this.pickedMessagesIds = []
    },
    cancelPicking () {
      this.clearPickedMessages()
    },
    isMessagePicked (message) {
      return this.pickedMessagesIds.includes(message.id)
    },
    isForward (message) {
      return message.type === 10
    },
    onForward () {
      this.$modal.show('forward-to', {
        messageIdList: this.pickedMessagesIds,
        onClose: () => {
          this.clearPickedMessages()
        }
      })
    },
    onReply () {
      if (!this.isShowSingleActions) return
      this.repliedMessage = this.messageById(this.pickedMessagesIds[0])
      this.clearPickedMessages()
    },
    onEdit () {
      if (!this.isShowSingleActions) return
      this.editedMessage = this.messageById(this.pickedMessagesIds[0])
      this.text = this.editedMessage.payload
      this.subject = this.editedMessage.properties.subject
      this.clearPickedMessages()
    },
    onTextKeyupUp () {
      if (this.text) return
      const lastUserMessage = findLast(this.messages, msg => {
        return msg.senderId === this.user.id && msg.type === TYPE_CODE.text
      })
      if (!lastUserMessage) return
      this.editedMessage = lastUserMessage
      this.text = this.editedMessage.payload
      this.subject = this.editedMessage.properties.subject
    },
    onDelete () {
      this.$modal.show('delete-messages')
    },
    clearReply () {
      this.repliedMessage = null
    },
    clearEdit () {
      this.editedMessage = null
      this.text = ''
      this.subject = ''
    },
    async scrollToMessage (id) {
      this.isScrolling = true
      const idx = this.messages.findIndex(msg => msg.id === id)
      if (idx < 0) {
        await this.fetchMessages()
        this.$nextTick(() => {
          this.scrollToMessage(id)
        })
        return
      }
      this.$scrollTo(`#m${id}`, 300, {
        container: this.$refs.messageList,
        easing: 'ease-in',
        onDone: el => {
          const msgContainer = el.querySelector('.gl-message-container')
          msgContainer.classList.add('highlighted')
          setTimeout(() => {
            msgContainer.classList.remove('highlighted')
          }, 1000)
          this.isScrolling = false
        }
      })
    },
    onDragEnter () {
      this.isDropFile = true
    },
    onDragLeave () {
      this.isDropFile = false
    },
    onDrop (event) {
      const file = get(event, 'dataTransfer.files[0]')
      this.isDropFile = false
      if (!file) return
      this.onFileChange(file)
    },
    async onTranslate () {
      if (!this.isPremium) return
      if (!this.$store.state.entities.translatedMessages.language) {
        this.$modal.show('settings')
        return
      }
      this.isTranslating = true
      try {
        await this.translate(this.pickedMessagesIds)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
      this.isTranslating = false
      this.clearPickedMessages()
    },
    onTextInput (e) {
      const value = e.target.value
      this.text = value

      const selectionStart = e.target.selectionStart
      this.pointPositionTextarea = selectionStart
      const textForFindMember = value.substr(0, selectionStart)
      const lastIndexDog = textForFindMember.lastIndexOf('@')
      const currentMemberName = textForFindMember.substr(lastIndexDog, selectionStart - lastIndexDog)
      const prevLetter = value.charAt(selectionStart - 2)
      if (
        currentMemberName.length > 0 &&
        !currentMemberName.includes(' ') &&
        currentMemberName.includes('@') &&
        (prevLetter === ' ' || prevLetter === '')
      ) {
        this.mentionText = currentMemberName
        this.isShowMentions = true
      } else {
        this.mentionText = ''
        this.isShowMentions = false
      }
      if (e.data === '@' && (prevLetter === ' ' || prevLetter === '')) {
        this.isShowMentions = true
      } else if (e.data === ' ') {
        this.hideMentions()
      }
      this.onTyping()
    },
    onTyping: throttle(
      function () {
        this.typing(this.activeChatId)
      },
      2000,
      { leading: true, trailing: false }
    ),
    hideMentions () {
      this.isShowMentions = false
    },
    insertMention (nickname) {
      const copyText = this.text.slice()
      const textPart1 = copyText.substr(0, this.pointPositionTextarea)
      const textPart2 = copyText.substr(this.pointPositionTextarea, copyText.length)
      const result = textPart1.replaceLast(this.mentionText, `@${nickname}`)
      this.text = `${result}${textPart2 || ''}`
      this.hideMentions()
    },
    onVoice () {
      this.isVoiceRecording = true
    },
    async sendVoice ({ file, duration }) {
      this.isVoiceRecording = false
      const link = await api.media.upload(file)
      const [data] = this.prepareMessagesData({
        type: TYPE_CODE.voice,
        payload: {
          link,
          duration,
          size: file.size
        }
      })
      setTimeout(this.goBottom, 0)
      await this.sendMessage(data)
    }
  }
}
</script>

<style module lang="scss">
%padding {
  padding: 0 50px;
}
.container {
  // flex-basis: 0;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.dropzone {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 4;
  text-align: center;
  background-image: linear-gradient(90deg, $text-mid 50%, #fff 50%), linear-gradient(90deg, $text-mid 50%, #fff 50%),
    linear-gradient(0deg, $text-mid 50%, #fff 50%), linear-gradient(0deg, $text-mid 50%, #fff 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
  background-position: left top, right bottom, left bottom, right top;
  animation: border-dance 0.5s infinite linear;
  * {
    pointer-events: none;
  }
  &Text {
    top: 50%;
    position: relative;
    z-index: 3;
    font-size: 16px;
    color: $text-mid-dark;
  }
  &Icon {
    font-size: 30px;
    margin-bottom: 16px;
  }
  &::before {
    content: '';
    position: absolute;
    z-index: 3;
    top: 2px;
    left: 2px;
    height: calc(100% - 4px);
    width: calc(100% - 4px);
    background-color: rgba(#fff, 0.9);
  }
}
@keyframes border-dance {
  0% {
    background-position: left top, right bottom, left bottom, right top;
  }
  100% {
    background-position: left 15px top, right 15px bottom, left bottom 15px, right top 15px;
  }
}
.placeholder {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: $text-mid;
  // padding: 20px;
  // width: 60%;
  // margin: 0 auto;
  // border-radius: 5px;
  // background-color: rgba($main-bg-colored, 0.2);
}
.infiniteLoading {
  height: 50px;
  padding-top: 5px;
}

.messageListWrap {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.messageList {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100%;
  padding-bottom: 20px;
  width: 100%;

  &Active > .messageItem:hover > :global(.gl-message-container) {
    background-color: rgba($main-bg-colored, 0.2);
  }
}

.bottomWrap {
  min-height: 85px;
  border: 1px solid transparent;
  border-top: 1px solid $border-color;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
}
.extraBlock {
  width: 410px;
  margin-left: 104px;
}
.attachmentPreview {
  color: $text-colored;
  position: relative;
  margin: 4px 0;
  display: flex;
  padding-right: 44px;
  &Body {
    flex-grow: 1;
    min-width: 0;
  }
  &Name {
    @include ellipsis();
    padding: 0 8px;
  }
  &Size {
    flex-shrink: 0;
    color: $text-mid;
  }
  &Close {
    position: absolute;
    right: 0;
    top: 3px;
    font-size: 10px;
    cursor: pointer;
    color: $text-dark;
  }
}
.sendMessageForm {
  @extend %padding;
  display: flex;
  // align-items: flex-end;
  // margin-top: 12px;
  // margin-bottom: 10px;
}

.avatarContainer {
  padding-right: 14px;
  flex-shrink: 0;
}
.messageContainer {
  // flex-grow: 1;
  flex-basis: 410px;
  margin-right: 14px;
  position: relative;
}
.inputSubject,
.input {
  border: none;
  position: relative;
  z-index: 2;
  border-bottom: 1px solid $transparent;
}
.inputSubject {
  font-size: 12px;
  margin-bottom: 4px;
  width: 40%;
  &::placeholder {
    color: $text-light;
    font-size: 10px;
  }
  &:focus::placeholder {
    color: $text-mid;
  }
}
.input {
  width: 100%;
  &:focus {
    border-bottom: 1px solid $main-bg-colored;
  }
}
.buttons {
  flex-shrink: 0;
  padding-left: 12px;
}
.reply {
  width: 100%;
  position: absolute;
  z-index: 1;
  top: -40px;
  // transition: transform 0.1s;
}
.buttonSend {
  text-transform: uppercase;
  background-color: #fff;
  color: $text-colored;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  &Icon {
    transform: rotate(135deg);
    margin-left: 6px;
    font-size: 18px;
  }
}
.buttonsMore {
  display: flex;
  flex-basis: 50%;
  align-items: center;
  margin-bottom: 12px;
}

.btnMore {
  color: $text-light;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.1s;
  &:hover {
    transform: scale(1.1);
  }
}

.actions {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @extend %padding;

  &Group {
    display: flex;
  }
  &Button:global(.form--button.button--oval) {
    margin-right: 10px;
    width: auto;
  }
}
.replyClose {
  color: $text-light;
  cursor: pointer;
  font-size: 14px;
  margin-top: 4px;
}
:global(.tooltip.popover) .picker:global(.popover-inner) {
  border-radius: 4px;
}
.mentionWrap {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  max-height: 180px;
  overflow-y: auto;
  background: $white;
  border-top: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.05);
}
.mentionUserList {
}
.mentionUserItem {
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: background-color 0.05s ease, color 0.05s ease;
  &:hover {
    color: $text-lightest;
    background-color: rgba($main-bg-colored, 0.2);
  }
}
.mentionUserItemAvatar {
}
.mentionUserItemName {
  padding-left: 8px;
  color: $text-dark;
  strong {
    color: $black;
    font-weight: 600;
  }
}
</style>
